// Gudang Rido · kartu Cetak Mockup ringkas: akun → nomor (salin) → status · teknik → desainer · waktu masuk.
import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { TokopediaAttachments } from "./channel";
import { TokopediaDeadline } from "./tokopedia_deadline";
import { SHOPEE_PROCESS_LABEL } from "./shopee_module";

const pad = (n) => String(n).padStart(2, "0");
const when = (iso) => {
  if (!iso) return "—";
  const d = new Date(iso);
  return isNaN(d) ? "—" : `${pad(d.getDate())}/${pad(d.getMonth() + 1)} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

function CopyBtn({ text, testId }) {
  const [ok, setOk] = useState(false);
  const copy = async (e) => {
    e.stopPropagation();
    try { await navigator.clipboard.writeText(text); setOk(true); setTimeout(() => setOk(false), 1200); } catch { /* izin clipboard ditolak */ }
  };
  return <button type="button" className="rdc-copy" onClick={copy} onKeyDown={e => e.stopPropagation()}
    aria-label={`Salin nomor pesanan ${text}`} title="Salin nomor pesanan" data-testid={testId}>
    {ok ? <Check size={13}/> : <Copy size={13}/>}</button>;
}

export function RidoCardInfo({ job, badge, allDl, designerUpdated }) {
  return <div className="shopee-wh-info rdc-info">
    <div className="rdc-account" title={job.customer_account || ""} data-testid={`wh-shopee-card-account-${job.id}`}>{job.customer_account || "—"}</div>
    <div className="rdc-order">
      <span className="shopee-order-number" data-testid={`wh-shopee-card-order-${job.id}`}>{job.order_number}</span>
<TokopediaAttachments orderNumber={job.order_number}/>
      <CopyBtn text={job.order_number} testId={`wh-shopee-card-copy-${job.id}`}/>
    </div>
    <div className="rdc-line">
      <span className="shopee-status-badge" style={{ background: badge.bg, color: badge.c }} data-testid={`wh-shopee-state-${job.id}`}>{badge.t}</span>
      {job.process && <span className="rdc-tech" data-testid={`wh-shopee-process-${job.id}`}>{SHOPEE_PROCESS_LABEL[job.process] || job.process}</span>}
      {designerUpdated && <span className="rdc-flag" data-testid={`wh-shopee-designer-updated-${job.id}`}>Diperbarui desainer</span>}
      {allDl && <span className="rdc-flag rdc-flag-ok" data-testid={`wh-shopee-all-downloaded-${job.id}`}>Sudah diunduh</span>}
    </div>
    <TokopediaDeadline orderNumber={job.order_number}/>
    <div className="rdc-meta" title={`Desainer ${job.pic_designer_name || "-"} · masuk Gudang ${when(job.warehouse_sent_at)}`}>
      <span>Desainer <b data-testid={`wh-shopee-card-designer-${job.id}`}>{job.pic_designer_name || "—"}</b></span>
      <span aria-hidden="true">·</span>
      <span data-testid={`wh-shopee-card-sent-at-${job.id}`}>Masuk {when(job.warehouse_sent_at)}</span>
    </div>
  </div>;
}
